import { FelaCSS, colors } from '@bridebook/ui';

interface IStyle {
  wrapper: FelaCSS;
}

const styles = (): IStyle => ({
  wrapper: {
    position: 'absolute',
    left: '50%',
    bottom: 12,
    transform: 'translateX(-50%)',
    color: colors.white,
    background: 'rgba(0,0,0,0.7)',
    borderRadius: 5,
    fontSystem: 12,
    paddingVertical: 1,
    paddingHorizontal: 2,
    zIndex: 11,
  },
});

export default styles;
